import PropTypes from 'prop-types'

const GarageContentSlotMain = ({ placeholders: { contents = []} = {}}) => contents

GarageContentSlotMain.propTypes = {
  placeholders: PropTypes.shape({
    contents: PropTypes.arrayOf()
  })
}

GarageContentSlotMain.type = 'GarageContentSlotMain'
GarageContentSlotMain.placeholders = ['contents']

export default GarageContentSlotMain
